import { Trash2 } from "lucide-react";

import { cn } from "../../lib/utils";
import { ui } from "@patient-watch/ui";
import { buttonVariants } from "@patient-watch/ui/button";
import { useActionCopy } from "@/features/i18n/actionCopy";
import { formComponents as fc } from "@/features/i18n/formComponents";

interface Props {
    words?: string;
    deleteFunction: () => void;
    size?: "sm" | "md" | "lg";
    variant?: "destructive" | "destructive-secondary" | "destructive-link";
    className?: string;
}

const DeleteButton = (props: Props) => {
    const copy = useActionCopy();

    return (
        <ui.AlertDialog>
            <ui.AlertDialogTrigger
                className={cn(
                    "flex items-center gap-2",
                    buttonVariants({
                        size: props.size ?? "lg",
                        variant: props.variant ?? "destructive-secondary",
                    }),
                    props.className
                )}
            >
                <Trash2 size={20} />
                {props.words || "Delete"}
            </ui.AlertDialogTrigger>

            <ui.AlertDialogContent className="max-w-md">
                <ui.AlertDialogHeader>
                    <ui.AlertDialogTitle>{copy.deleteConfirmTitle}</ui.AlertDialogTitle>
                    <ui.AlertDialogDescription>{copy.deleteConfirmDescription}</ui.AlertDialogDescription>
                </ui.AlertDialogHeader>
                <ui.AlertDialogFooter className="flex md:flex-row flex-col gap-y-4">
                    <ui.AlertDialogAction asChild>
                        <fc.DeleteButton
                            variant="destructive"
                            size="lg"
                            onClick={props.deleteFunction}
                            className="w-auto"
                        />
                    </ui.AlertDialogAction>
                    <ui.AlertDialogCancel asChild>
                        <fc.CancelButton variant="outline" size="lg" className="w-auto text-slate-800" />
                    </ui.AlertDialogCancel>
                </ui.AlertDialogFooter>
            </ui.AlertDialogContent>
        </ui.AlertDialog>
    );
};

export default DeleteButton;
